const DATE_DIGIT_COUNT = 8

export const formatDate = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '').slice(0, DATE_DIGIT_COUNT)

  const [day, month, year] = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)]

  return [day, month && `/${month}`, year && `/${year}`].filter(Boolean).join('')
}
